import consumer from "./consumer"

// O bundle roda com defer (Shakapacker 9), portanto executa DEPOIS do DOM estar pronto.
// Basta ler o data-plan-id do elemento #boleto-payment-listener que é inserido pelo layout
// ou pela view boleto_pending. Não precisa de inline script na view.

let currentSub = null;
let currentPlanId = null;

function syncBoletoSubscription() {
  const el = document.getElementById('boleto-payment-listener');

  if (!el) {
    if (currentSub) {
      currentSub.unsubscribe();
      currentSub = null;
      currentPlanId = null;
    }
    return;
  }

  const planId = String(el.dataset.planId || '');
  if (!planId) return;
  if (currentSub && currentPlanId === planId) return;

  if (currentSub) {
    currentSub.unsubscribe();
    currentSub = null;
    currentPlanId = null;
  }

  currentSub = consumer.subscriptions.create(
    { channel: 'BoletoPaymentChannel', company_plan_id: planId },
    {
      connected() {},
      disconnected() {},
      rejected() {},
      received(data) {
        if (data.event === 'charge.paid') {
          window.location.reload();
        }
      }
    }
  );
  currentPlanId = planId;
}

document.addEventListener('DOMContentLoaded', () => syncBoletoSubscription());
document.addEventListener('turbolinks:load', () => syncBoletoSubscription());

document.addEventListener('turbolinks:before-cache', () => {
  if (currentSub) {
    currentSub.unsubscribe();
    currentSub = null;
    currentPlanId = null;
  }
});


